module.exports = __webpack_public_path__ + "static/img/mep-bg1.6aada530.png";